export default __webpack_public_path__ + "static/media/campaign-active.dea34d88.svg";